import * as data from '@/runtime-components/data';

const components = [
	{
		title: '饼图',
		tag: 'de-pie',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: '外半径',
				name: 'outradius',
				type:{ name: 'percent'},
				default: 70
			},
			{
				title: '内半径',
				name: 'innerradius',
				type:{ name: 'percent'},
				default: 50
			},
			{
				title: '标题位置',
				name: 'legendOrient',
				type: {
					name: 'radio',
					options: {
						data: [{
							label: '垂直排列',
							value: 'vertical'
						}, {
							label: '水平排列',
							value: 'horizontal'
						}]
					}
				},
				default: 'vertical'
			},
			{
				title:"数据",
				name:"data",
				type:{ name:"data-json"},
				default: data.pieData.data
			},
			{
			  title:"系列颜色",
			  name:"colorSeries",
			  type:{ name:"series-color"},
			  default: data.pieData.colorSeries()
			}
		]
	},
	{
		title: '无痕折线图',
		tag: 'de-xa-noline',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.noLineData.data
			}
		]
	},
	{
		title: '折线图',
		tag: 'de-line',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: '区域颜色',
				name: 'areaColor',
				type:{ name: 'color'},
				default: '#83bff6'
			},
			{
				title: '线条颜色',
				name: 'lineColor',
				type:{ name: 'color'},
				default: '#2D8CF0'
			},
			{
				title:"数据",
				name:"data",
				type:{ name:"data-json"},
				default: data.lineData
			}
		]
	},
	{
		title: '折线图',
		tag: 'de-xa-line',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: '更换数据',
				name: 'type',
				type: {
					name: 'select',
					options: {
						list: [{
							label: '周数据',
							value: 'week'
						}, {
							label: '时数据',
							value: 'hour'
						}]
					}
				},
				default: {
					label: '周数据',
					value: 'week'
				}
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: {
					week: data.xaLineData,
					hour: data.xaFlowLineData
				}
			}
		]
	},
	{
		title: '堆积折线图',
		tag: 'de-lines',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: "显示标题",
				name: "shows",
				type: {
				  name: "bool"
				},
				default: true
			},
			{
				title: '标题',
				name: 'legend',
				type: {
					name: 'text'
				},
				default: '邮件营销, 联盟广告, 视频广告, 直接访问, 搜索引擎'
			},
			{
				title:"数据",
				name:"data",
				type:{ name:"data-json"},
				default: data.linesData
			}
		]
	},
	{
		title:"简单柱状图",
		tag:"de-bar",
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:400, height:200
		},
		events:[
			{
				name:'hoverItem',
				title:'鼠标悬浮到数据项',
				mockData:{
					test:1
				}
			}
		],
		eventHandlers:[
			{
				name:'highlightItem',
				title:'高亮数据项'
			}
		],
		props:[
			{
				title:"颜色",
				name: 'color',
				type:{ name: 'color'},
				default:'green',
			},
			{
				title:"x轴数据",
				name:'xAxis',
				type:{ name:'axis-data',options:{
					data:"@data"
				}},
				default:{
					rowOrColumn:'row', index:0
				}
			},
			{
				title:"系列",
				name:'series',
				type:{ name:'series-data',options:{
					data:"@data"
				}},
				default:{
					rowOrColumn:'row', indexs:[2]
				}
			},
			{
				title:"数据",
				name:"data",
				type:{ 
					name:"dataset", 
					options:{
						format:'2d-table'
					}
				},
				async:true,
				// default:{
				// 	url:'../../testdata/chart/bar.json'
				// }
				default:[
					["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
					["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
					[820, 932, 901, 934, 1290, 1330, 1320]
				]
			}
		]
	},
	{
		title: '柱状图',
		tag: 'de-xa-bar',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.xaBarData
			}
		]
	},
	{
		title: '折柱复合图',
		tag: 'de-line-bar',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title: '柱颜色',
				name: 'barColor',
				type:{ name: 'color'},
				default: 'rgba(17,161,248,1)'
			},
			{
				title: '折线颜色',
				name: 'lineColor',
				type:{ name: 'color'},
				default: '#8ec6ad'
			},
			{
				title:"数据",
				name:"data",
				type:{ name:"data-json"},
				default: data.lineBarData
			}
		]
	},
	{
		title: '多柱图',
		tag: 'de-bars',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'legend',
				type: {name: 'text'},
				default: '蒸发量,降水量,平均温度'
			},
			{
				title: '旋转角度',
				name: 'nameRotate',
				description: 'x轴名字旋转角度，默认为0不旋转',
				type: {name: 'number'},
				default: 0
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.barsData
			}
		]
	},
	{
		title: '双y轴',
		tag: 'de-twoY',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'legend',
				type: {name: 'text'},
				default: '蒸发量,降水量,平均温度'
			},
			{
				title: '旋转角度',
				name: 'rotate',
				description: 'x轴名字旋转角度，默认为0不旋转',
				type: {name: 'number'},
				default: 0
			},
			{
				title: '数据-Y轴',
				name: 'yIndex',
				description: '数据与Y轴左右轴的对应关系，0为左轴，1为右轴，0、1顺序同数据排列顺序',
				type: {name: 'text'},
				default: '0,0,1'
			},
			{
				title: '左轴单位',
				name: 'leftYUnit',
				type: {name: 'text'},
				default: 'ml'
			},
			{
				title: '右轴单位',
				name: 'rightYUnit',
				type: {name: 'text'},
				default: '°C'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.twoyData
			}
		]
	},
	{
		title: '动态柱状图',
		tag: 'de-active-twobar',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '动画',
				name: 'animate',
				type: { name: 'switch' },
				default: true
			},
			{
				title: '内容标题',
				name: 'title',
				type: {
					name: 'text'
				},
				default: '年保有量渗透率 (占终端)'
			},
			{
				title: '项目一',
				name: 'name1',
				type: {
					name: 'text'
				},
				default: '智能电视'
			},
			{
				title: '项目二',
				name: 'name2',
				type: {
					name: 'text'
				},
				default: '传统电视'
			},
			{
				title: '数据',
				name: 'barData',
				type: {
					name: 'data-json'
				},
				default: data.activeTwoBarData
			}
		]
	},
	{
		title: '水位图',
		tag: 'de-liquid',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:150, height:150
		},
		props: [
			{
				title: "圆环大小",
				name: "radius",
				type: {name: "percent"},
				default: 96
			},
			{
				title: "比例数",
				name: "data",
				type:{ name: "percent"},
				default: 50
			},
			{
				title: "百分比字体样式",
				name: "fontObj",
				type:{ name: "font"},
				default: {
					fontSize: 30,
					fontStyle: 'normal',
					color: '#fff'
				}
			}
		]
	},
	{
		title: '水位图组件',
		tag: 'de-liquid-part',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width: 180, 
			height: 120
		},
		props: [
			{
				title: "百分比",
				name: "percent",
				type: {
					name:"percent"
				},
				default: 57
			},
			{
				title: "圆环大小",
				name: "radius",
				type: {name: "percent"},
				default: 66
			},
			{
				title: "圆环字体",
				name: "liquidFontObj",
				type: {
					name:"font"
				},
				default: {
					fontSize: 16,
					fontStyle: 'normal',
					color: '#fff'
				}
			}, 
			{
				title: "标题",
				name: "title",
				type: {
					name:"text"
				},
				default: '京津冀'
			},
			{
				title: "总数",
				name: "total",
				type: {
					name:"number"
				},
				default: 5989
			},
			{
				title: "内容样式",
				name: "titleFontObj",
				type: {
					name:"font"
				},
				default: {
					fontSize: 12,
					fontStyle: 'normal',
					color: '#fff'
				}
			},
			{
				title: '内容间距',
				name: 'lineHeight',
				type: {
					name: 'number'
				},
				default: 38
			},
			{
				title: '图文间距',
				name: 'margin',
				type: {
					name: 'number'
				},
				default: -12
			}
		]
	},
	{
		title: '散点图',
		tag: 'de-xa-scatter',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '颜色',
				name: 'color',
				type: {
					name: 'color'
				},
				default: '#FF8700'
			},
			{
				title: '散点大小',
				name: 'symbolSize',
				type: {
					name: 'number'
				},
				default: 10
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.scatterData
			}
		]
	},
	{
		title: '气泡图',
		tag: 'de-bubble',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'legend',
				type: {name: 'text'},
				default: '北京,上海,广州'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.bubbleData
			}
		]
	},
	{
		title: '气泡图',
		tag: 'de-scatter',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			// {
			// 	title: '标题',
			// 	name: 'legend',
			// 	type: {name: 'text'},
			// 	default: '1990,2015'
			// },
			{
				title: 'x轴名字',
				name: 'xName',
				type: {name: 'text'},
				default: 'GDP'
			},
			{
				title: 'y轴名字',
				name: 'yName',
				type: {name: 'text'},
				default: '年龄'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.relationScatterData
			}
		]
	},
	{
		title: '动态气泡词云',
		tag: 'de-active-bubble',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'legend',
				type: {
					name: 'text'
				},
				default: '蒸发量，降水量，平均温度'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.activeBubbleData
			}
		]
	},
	{
		title: '雷达图',
		tag: 'de-radar',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'legend',
				type: {
					name: 'text'
				},
				default: '预算分配,实际开销'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.radarData
			}
		]
	},
	{
		title: '仪表盘',
		tag: 'de-gauge',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'title',
				description: '非编辑状态下鼠标移入仪表盘显示的标题',
				type: {
					name: 'text'
				},
				default: '速度'
			},
			{
				title: '单位',
				name: 'unit',
				type: {
					name: 'text'
				},
				default: 'km/h'
			},
			{
				title: '值',
				name: 'val',
				type: {
					name: 'number'
				},
				default: 35
			}
		]
	},
	{
		title: '漏斗图',
		tag: 'de-funnel',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '显示标题',
				name: 'legend',
				type: {
					name: 'switch'
				},
				default: true
			},
			{
				title: '数据',
				name: 'data',
				type: { name: 'data-json' },
				default: data.funnelData
			}
		]
	},
	{
		title: '树状图',
		tag: 'de-treemap',
		resizeMethod: 'resizeChart',
		group:'chart',
		defaultSize:{
			width:300, height:150
		},
		props: [
			{
				title:"数据",
				name:"data",
				type:{ name:"data-json"},
				default: data.treemapData
			}
		]
	},
	{
		title: '锥形柱图',
		tag: 'de-core-bar',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '颜色',
				name: 'color',
				type: {
					name: 'color'
				},
				default: '#e54035'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.coneData()
			}
		]
	},
	{	
		title: '个性柱状图',
		tag: 'de-customBar',
		resizeMethod: 'resizeChart',
		group:'chart',
		props: [
			{
				title: '标题',
				name: 'legend',
				type: {
					name: 'text'
				},
				default: 'line,bar'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json'
				},
				default: data.customBarData
			}
		]
	},
]
export default components;